import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeroImage from './preview_room_hero_bg.jpg';
import TerapiLogo from '../../images/desktop_new_logo.svg';
import * as twilio from 'twilio-video';
import Moment from 'react-moment';

function getAndroidVersion(ua) {
    ua = (ua || navigator.userAgent).toLowerCase(); 
    var match = ua.match(/android\s([0-9\.]*)/i);
    return match ? match[1] : undefined;
};

class PreviewRoom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      video_accepted: null,
    };
    this.remote_part = this.getRemotePart();
    this.current_date = new Date();
    this.local_video = null;
    console.log(this.props.holderToken)
    console.log(this.props.roomToken)
  }

  componentDidMount() {
    console.log('Creating Local Video Track')
    const self = this;
    twilio.createLocalVideoTrack().then(track => {
        //const localMediaContainer = document.getElementById('local-media');
        //localMediaContainer.appendChild(track.attach());
        console.log("Video accepted");
        self.setState({ video_accepted: true });
        track.stop();
        track.detach().forEach(element => element.remove());
    }).catch(error => {
        if (error.name === "NotAllowedError") {
          console.log("Not allowed error");
          self.setState({ video_accepted: false });
        }
    });

    console.log('After creating local video track');
  }


  getRemotePart() {
    if (this.props.holder.type === this.props.appointment.patient.type) {
      return this.props.appointment.professional;
    }
    return this.props.appointment.patient;
  }

  render() {

    const welcomeMessage = {
      padding: "15px",
    };

    const messageContainer = {
      marginTop: "100px",
    };

    const brandColumn = {
      paddingLeft: "30px",
    };

    const logo = {
      width: "250px",
    };

    const dateMessage = {
      marginTop: "10px",
      marginLeft: "10px",
      fontSize: "1.8em",
    };

    const sessionInformationTextColor = {
      color: "rgb(74, 74, 74)",
    };

    const sessionContainer = {
      backgroundColor: "#35cce6",
      marginLeft: "-20px",
      marginRight: "-20px",
      paddingTop: "15px",
      marginBottom: "20px",
      marginTop: "20px",
    };

    const remoteContainer = {
      paddingTop: "10px",
      paddingLeft: "35px",
    };

    const remoteFigure = {
      width: "70px",
      height: "70px",
      borderRadius: "50%",
      overflow: "hidden",
    };

    const remoteImage = {
      width: "70px",
      height: "auto",
    };

    const fullButton = {
      width: "100%",
      marginTop: "15px",
    };

    const videoPreview = {
      width: "240px",
      height: "240px",
      marginLeft: "15px",
      marginTop: "-110px",
      paddingTop: "15px",
    };

    const videoWarning = {
      backgroundColor: "#e80000",
      padding: "15px",
      textAlign: "center",
    };

    return (
      <div>
        <header className="static">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-6">
                <div id="logo_home" className="img-fluid-2">
                  <img className="image-fluid" height="26" src={ TerapiLogo } />
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="content-wraper">
          <div className="container margin_60_35">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="box_general_3 box_preview">
                  <div className="head_preview">
                    <h2>¿Listo para tu consulta con {this.remote_part.name}?</h2>
                  </div>
                  {   this.state.video_accepted == null &&
                      <div className="alert alert-danger">
                        Debes aceptar el uso de tu c&aacute;mara web para ingresar. Si no se te preguntó nada, por favor recarga la página y/o intenta con otro navegador y/o revisa las opciones de privacidad de tu dispositivo y confirma que la cámara no este bloqueada. 
                        <a href="https://terapi-app.com/instrucciones-chrome" target="_blank">
                           Sí estás en Google Chrome en móvil presiona aquí
                        </a>                      
                      </div> 
                  }
                  {
                    (this.state.video_accepted != null && this.state.video_accepted === false) &&
                    <div className="alert alert-danger">
                      Debes aceptar el uso de tu c&aacute;mara web para ingresar a la video-conferencia. Recarga la p&aacute;gina e intenta nuevamente. Si no se te preguntó nada, por favor recarga la página y/o intenta con otro navegador y/o revisa las opciones de privacidad de tu dispositivo y confirma que la cámara no este bloqueada. 
                      <a href="https://terapi-app.com/instrucciones-chrome" target="_blank">
                         Sí estás en Google Chrome en móvil presiona aquí
                      </a> 
                    </div>
                  }
                  {
                    (this.state.video_accepted != null && this.state.video_accepted === true) &&
                    <div className="alert alert-success">
                      Tu cámara esta conectada.
                    </div>
                  }
                  {
                    (this.state.video_accepted == null || this.state.video_accepted === false) &&
                    <div>
                      <p>Si no has podido activar tu cámara por favor <span color="red"> comprueba lo siguiente:</span></p>
                      <ul>
                        <li> Comprueba que tu navegador es compatible para nuestro sistemas de video conferencias.  Los navegadores
                        compatibles en Android son <b> Chrome y Firefox </b>, en iOS <b> es Safari </b> y en computador son los navegadores <b> Chrome y Firefox </b>.
                        Ciertas versiones de <b>Firefox</b> pueden no funcionar, si tienes problemas, por favor intenta con <b>Google Chrome</b>.
                        </li>
                        <li> Cierra todos los otros programas, ya que alguno puede estar usando la cámara y no permitirle a Terapi usarla.</li>
                        <li> Si estas en móvil asegurate en configuración que el navegador pueda acceder a tu cámara y micrófono. <a href="https://terapi-app.com/instrucciones-chrome" target="_blank">
                          Sí está en Google Chrome en móvil presione aquí
                        </a> 
                        </li>
                      </ul>
                    </div>
                  }
                  <p>Para entrar presiona <span color="green">aceptar</span>, luego se te pedirá aceptar el micrófono y cámara nuevamente. Algunas recomendaciones:</p>
                  <ul>
                    <li> Si estas en <b>celular</b>, recuerda seleccionar tu <b>cámara frontal</b> cuando se te pregunte.
                    </li>
                    <li> Busca un lugar <b>cómodo, privado y sin ruido</b> para conversar con tu {this.props.holder.type == "user"? "terapeuta" : "paciente"}.
                    </li>
                    <li> La conversación es totalmente <b>privada</b>, ni tu, ni tu {this.props.holder.type == "user"? "psicólogo" : "paciente"} pueden grabar esta conversación.
                    </li>
                  </ul>
                  <p> Si ya comprobaste todo, presione en Entrar, esperamos que esta sesión sea provechosa.</p>
                  <div className="row">
                    <div className="col-lg-6">
                      <a href="#" className={`btn btn-info ${(this.state.video_accepted === false || this.state.video_accepted === null) ? 'disabled' : ''}`} style={ fullButton } onClick={this.props.connectRoomHandler}>
                        Entrar
                      </a>
                    </div>
                    <div className="col-lg-6">
                      <a href={this.props.holder.type == "user" ? `/${this.props.site}/main/users/panel-usuario` : `/${this.props.site}/main/psychologists/panel`} className={`btn btn-info`} style={ fullButton } >
                        Volver
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PreviewRoom.propTypes = {
  appointment: PropTypes.shape({
    patient: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
    }).isRequired,
    professional: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
    }).isRequired,
    start_time: PropTypes.string.isRequired,
  }).isRequired,
  holder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
  }).isRequired,
  connectRoomHandler: PropTypes.func.isRequired,
};

export default PreviewRoom;
